export default __webpack_public_path__ + "static/media/feature-3.1ad78b2f.png";